import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const Accessories = ({ roles }) => {

    return (
        <M_Table entityName={'Accessory'} filtersOnTable rolePermissions={roles} />
    )
}